/**
 * Grow a textarea to fit its text, so the whole of what is being edited is
 * visible without an inner scrollbar (Ed, 2026-09-24: carer guidance was
 * edited through a six-line keyhole). The box never shrinks below its CSS
 * min-height, and re-fits on every keystroke.
 */
export function fitToContent(el: HTMLTextAreaElement): void {
  el.style.height = "auto";
  el.style.height = `${el.scrollHeight + 2}px`;   // +2: the 1px borders
}

/** Fit every matching textarea under `root` now, and as it is typed in. */
export function autosizeTextareas(root: ParentNode, selector: string): void {
  root.querySelectorAll<HTMLTextAreaElement>(selector).forEach((el) => {
    fitToContent(el);
    el.addEventListener("input", () => fitToContent(el));
  });
}
